// This icon file is generated automatically.
var PCiOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M7 0a7 7 0 100 14A7 7 0 007 0zm0 12.81A5.81 5.81 0 117 1.2 5.81 5.81 0 017 12.8zm3.4-8.94h-.78a.13.13 0 00-.13.13v6c0 .07.06.13.13.13h.79c.06 0 .12-.06.12-.13V4a.13.13 0 00-.12-.13zM6 4.65c.78 0 1.3.5 1.37 1.21 0 .07.06.12.12.12h.83c.03 0 .06-.03.06-.07 0-1.27-1-2.16-2.38-2.16-1.6 0-2.53 1.09-2.53 2.88v.77c0 1.78.93 2.85 2.53 2.85 1.38 0 2.38-.86 2.38-2.07a.07.07 0 00-.06-.07h-.83a.13.13 0 00-.12.12C7.3 8.9 6.77 9.36 6 9.36c-.96 0-1.5-.7-1.5-1.96v-.77c0-1.27.54-1.98 1.5-1.98z", "fill-rule": "nonzero" } }] }, "name": "p-ci", "theme": "outlined" };
export default PCiOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PCiOutlined.js
// module id = 3280
// module chunks = 0